// React
import { ReactNode } from "react"

// UI
import { PageTemplate, PageTemplateLink } from "@/layouts/PageTemplate"

// Translations
import { useTrans } from "@/i18n"

// Pages
import { Routes } from "@/constants/routes"

/**
 * CommunitySubMenuTabs
 * @returns
 */
function CommunitySubMenuTabs() {
	const t = useTrans("investor")

	return (
		<>
			<PageTemplateLink
				to={Routes.CommunityShare}
				name={t("investor:investor.community.invites.title")}
			/>
		</>
	)
}

/**
 * CommunityLayout
 * @param param0
 * @returns
 */
export function CommunityLayout({ children }: { children: ReactNode }) {
	const t = useTrans("common")

	// Return
	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("common:common.nav.community"),
				})}
			</title>
			<PageTemplate
				title={t("common:common.nav.community")}
				tabs={<CommunitySubMenuTabs />}
			>
				{children}
			</PageTemplate>
		</>
	)
}
